import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';

const VendorSection: React.FC = () => {
  const vendorCategories = [
    'Photographers', 'Venues', 'Caterers', 'Florists', 
    'DJs & Bands', 'Wedding Planners', 'Cake Designers', 'Videographers'
  ];
  
  const featuredVendors = [
    {
      name: 'Elegant Moments',
      category: 'Photographer',
      rating: 4.9,
      reviewCount: 87,
      image: 'https://images.pexels.com/photos/3014856/pexels-photo-3014856.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
    },
    {
      name: 'Divine Blooms',
      category: 'Florist',
      rating: 4.8,
      reviewCount: 64,
      image: 'https://images.pexels.com/photos/931158/pexels-photo-931158.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
    },
    {
      name: 'Riverfront Estate',
      category: 'Venue',
      rating: 4.9,
      reviewCount: 112,
      image: 'https://images.pexels.com/photos/1579253/pexels-photo-1579253.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
    }
  ];

  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section id="vendors" className="py-20 relative bg-white">
      <div className="absolute top-40 right-0 w-96 h-96 rounded-full bg-[#FF4E8E]/5 blur-3xl -z-10"></div>
      
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-[42px] font-bold font-cormorant-garamond leading-[1.2] text-[#1C1C1E] mb-6">
            Connect With Wedding Vendors <span className="italic text-[#FF4E8E]">Coming Soon</span>
          </h2>
          <p className="text-[#535353] font-cormorant-garamond">
            Browse our curated network of top-rated wedding professionals, read reviews, and book with confidence.
          </p>
        </div>
        
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {vendorCategories.map((category, index) => (
            <button
              key={index}
              className={`px-6 py-3 rounded-full text-[14px] font-cormorant-garamond transition-all duration-300 ${
                index === 0 
                  ? 'bg-gradient-to-r from-[#FF69B4] to-[#FF7F50] text-white shadow-lg shadow-[#FF4E8E]/25' 
                  : 'text-[#FF4E8E] bg-[#FF4E8E]/10 hover:bg-[#FF4E8E]/20 border border-[#FF4E8E]/20'
              }`}
            >
              {category}
            </button>
          ))}
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {featuredVendors.map((vendor, index) => (
            <div key={index} className="bg-gradient-to-br from-[#FF69B4]/15 to-[#FFDAB9]/15 p-6 transition-all duration-300 hover:translate-y-[-3px] group relative w-full rounded-2xl">
              <div className="bg-white p-6 rounded-xl shadow-xl border border-[#FF4E8E]/20">
                <div className="aspect-[4/3] overflow-hidden rounded-lg">
                  <img 
                    src={vendor.image} 
                    alt={vendor.name} 
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" 
                  />
                </div>
                <div className="mt-4">
                  <div className="flex justify-between items-start gap-2 mb-2">
                    <h3 className="font-bold font-cormorant-garamond text-[16px] text-[#1C1C1E]">{vendor.name}</h3>
                    <div className="flex items-center">
                      <Star className="h-4 w-4 text-yellow-400 fill-yellow-400" />
                      <span className="ml-1 text-sm text-[#FF4E8E]">{vendor.rating}</span>
                    </div>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="italic font-cormorant-garamond text-[14px] text-[#535353]">{vendor.category}</span>
                    <span className="font-cormorant-garamond text-[13px] text-[#535353]">{vendor.reviewCount} reviews</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="bg-gradient-to-br from-[#FF69B4]/15 to-[#FFDAB9]/15 p-8 rounded-2xl">
          <div className="bg-white p-8 rounded-xl shadow-xl border border-[#FF4E8E]/20">
            <div className="flex flex-col md:flex-row items-center justify-between gap-8">
              <div className="flex-1 text-center md:text-left">
                <h3 className="text-2xl font-bold mb-3 text-[#1C1C1E] font-cormorant-garamond">Are you a wedding vendor?</h3>
                <p className="text-[#535353] font-cormorant-garamond text-[16px] leading-relaxed max-w-xl">
                  Join our network and connect with engaged couples planning their big day. 
                  <span className="block mt-2 text-[#FF4E8E] italic">
                    Grow your business with Wedify's trusted platform.
                  </span>
                </p>
              </div>
              <div className="flex flex-row items-center md:items-end gap-4 w-full md:w-auto">
                <Link 
                  to="/vendors" 
                  className="text-[#FF4E8E] underline hover:text-[#FF69B4] text-[16px] font-cormorant-garamond font-bold transition-colors duration-200"
                >
                  Learn More
                </Link>
                <div data-tf-live="01JV5FQXFJ4J5JH6EMD6YWVXFV"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VendorSection;